export default __webpack_public_path__ + "static/media/jerai-logo.e20abf89.png";